import React, { useState } from "react";
import { Modal, message, Switch, Spin } from "antd";
import { Link } from "react-router-dom";
import { DeleteIcon, Pen } from "../../assets/images/icons";
import { useUserContext } from "../../context/dashboard-context";
import axios from "axios";
import './categorycard.scss';
import { Form } from "react-bootstrap";

const Categorycard = ({
  id,
  name_uz,
  name_ru,
  name_en,
  featuredproduct = false,
  link,
  type,
  GetCategory,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [updatedUz, setUpdatedUz] = useState(name_uz);
  const [updatedRu, setUpdatedRu] = useState(name_ru);
  const [updatedEn, setUpdatedEn] = useState(name_en);
  const [featured, setFeatured] = useState(featuredproduct);
  const [switchbutton, setSwitch] = useState(featuredproduct);
  const [loading, setLoading] = useState(false);

  const { token } = useUserContext();

  const showModal = () => setIsModalOpen(true);
  const showEditForm = () => {
    setIsEditMode(true);
    showModal();
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setIsEditMode(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsEditMode(false);
  };

  const removeProduct = () => {
    setLoading(true);
    axios
      .delete(`https://api.unit-group.uz/${type}/${id}`, {
        headers: {
          Authorization: "Bearer " + token.access,
        },
      })
      .then(() => {
        GetCategory();
        handleOk();
        message.success("Kategoriya o‘chirildi");
      })
      .catch((err) => {
        console.error(err);
        message.error("Kategoriya o‘chirishda xatolik");
      })
      .finally(() => setLoading(false));
  };

  const updateProduct = () => {
    setLoading(true);
    axios
      .put(
        `https://api.unit-group.uz/category/${id}`,
        {
          name_uz: updatedUz,
          name_ru: updatedRu,
          name_en: updatedEn,
          featured: featured,
        },
        {
          headers: {
            Authorization: "Bearer " + token.access,
          },
        }
      )
      .then(() => {
        GetCategory();
        handleOk();
        message.success("Kategoriya yangilandi");
      })
      .catch((err) => {
        console.error(err);
        message.error("Kategoriya yangilanmadi");
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Spin spinning={loading}>
        <div className="categorycard_edit">
          <div className="card-img no-image">
            <div className="placeholder-icon">📦</div>
            <div className="card-edit">
              {link && (
                <Link to={`${link}${id}`} style={{ position: "absolute", left: "42%", top: "6%" }}>
                  <Pen />
                </Link>
              )}
              <button onClick={showEditForm}>
                <Pen />
                O‘zgartirish
              </button>
              <button onClick={removeProduct}>
                <DeleteIcon />
                O‘chirish
              </button>
            </div>
          </div>
          <div className="card-text">
            <h1>{name_uz}</h1>
          </div>
        </div>
      </Spin>

      <Modal
        title={isEditMode ? "Kategoriya o‘zgartirish" : "Kategoriya o‘chirish"}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Spin spinning={loading}>
          {isEditMode ? (
            <Form>
              <div className="product_edit_card">
                <div className="my-2 d-flex justify-content-between">
                  {/* <label>Top kategoriya</label> */}
                  {/* <Switch
                    onClick={() => setSwitch(!switchbutton)}
                    onChange={() => setFeatured(!featured)}
                    checked={switchbutton}
                  /> */}
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Nomi uz</Form.Label>
                  <Form.Control
                    type="text"
                    value={updatedUz}
                    onChange={(e) => setUpdatedUz(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Nomi ru</Form.Label>
                  <Form.Control
                    type="text"
                    value={updatedRu}
                    onChange={(e) => setUpdatedRu(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Nomi en</Form.Label>
                  <Form.Control
                    type="text"
                    value={updatedEn}
                    onChange={(e) => setUpdatedEn(e.target.value)}
                  />
                </Form.Group>

                <div className="modal-footer">
                  <button style={{fontSize: '1.05rem'}} onClick={handleCancel}>Bekor qilish</button>
                  <button className="product_edit_card_save" onClick={updateProduct}>
                    Saqlash
                  </button>
                </div>
              </div>
            </Form>
          ) : (
            <div>
              <p>Siz rostdan ham ushbu kategoriyani o‘chirmoqchimisiz?</p>
              <div className="modal-footer">
                <button onClick={handleCancel}>Bekor qilish</button>
                <button className="delete-btn" onClick={removeProduct}>O‘chirish</button>
              </div>
            </div>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default Categorycard;
